import { connectionData, endpoint } from 'data/apiConection.js/apiConnection';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const LoginFormCuotas = ({ hasLabel }) => {
  const navigate = useNavigate();
  
  // State
  const [formData, setFormData] = useState({
    dni: '',
  });
  const handleSubmit = async e => {
    e.preventDefault();
    toast.success(`Logging in as ${formData.dni}`, { theme: 'colored' });

    try {
      const responseLogin = await connectionData(endpoint, 'cuotas/alumno-dni', 'POST', formData);
      
      if ( responseLogin ) {
        console.log(responseLogin);
        validateUser(responseLogin);
      } else {
        toast.error("Login failed. Please check your credentials.", { theme: 'colored' });
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("An error occurred while logging in.", { theme: 'colored' });
    }
  };
  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const validateUser = (responseLogin) => {
    localStorage.setItem('father',JSON.stringify(responseLogin));
    navigate('/estados-cuentas');
  }
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>DNI</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Dni' : ''}
          value={formData.dni}
          name="dni"
          onChange={handleFieldChange}
          type="number"
        />
      </Form.Group>


      <Row className="justify-content-between align-items-center">

      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.dni}
        >
          Ingresar
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginFormCuotas.propTypes = {
  hasLabel: PropTypes.bool
};

LoginFormCuotas.defaultProps = {
  hasLabel: false
};

export default LoginFormCuotas;